import { useMemo } from 'react';
import PropertyNameToReferenceType from 'customer-data-objects/property/PropertyNameToReferenceType';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import useResolveReferenceType from 'flow-doctor-lib/hooks/useResolveReferenceType';

// Needed to get around the conditional calling of this hook in the consuming components, but never actually used anywhere
const DEFAULT_PROPERTY_WRAPPER = {
  property: {
    options: []
  },
  objectTypeId: '0-0'
};
export const VALID_REFERENCE_OPERATION_TYPES = ['string', 'number', 'enumeration'];
const getFallbackReferenceType = (propertyDef, objectTypeId) => {
  // Not all reference types are supplied by the BE, but this is a work in progress-
  // https://git.hubteam.com/HubSpot/InboundDbProperties/issues/3684
  const objectTypeIdOrLegacy = ObjectTypeFromIds[objectTypeId] || objectTypeId;
  const fallbackReferenceObjectProperties = PropertyNameToReferenceType[objectTypeIdOrLegacy];
  return fallbackReferenceObjectProperties && fallbackReferenceObjectProperties[propertyDef.name];
};

/**
 * @returns a mapping from option id to option label
 */
const useReferenceOptions = ({
  portalId,
  rawOptions = [],
  propertyWrapper = DEFAULT_PROPERTY_WRAPPER
}, {
  skip
}) => {
  const {
    objectTypeId,
    property: propertyDef
  } = propertyWrapper;
  const hasExternalOptions = propertyDef.externalOptions;
  const missingReferenceType = !propertyDef.referenceType;
  const fallbackReferenceType = getFallbackReferenceType(propertyDef, objectTypeId);
  const {
    data: optionLabelMappings
  } = useResolveReferenceType({
    portalId,
    referenceType: missingReferenceType && fallbackReferenceType ? fallbackReferenceType : propertyDef.referenceType,
    ids: rawOptions,
    objectTypeId
  }, {
    skip: skip || !hasExternalOptions
  });
  const mergedOptionLabelMappings = useMemo(() => propertyDef.options.reduce((acc, option) => Object.assign({}, acc, {
    [option.value]: option.label
  }), optionLabelMappings), [optionLabelMappings, propertyDef.options]);

  // This reduction is necessary because we use the raw option value as a fallback in the case
  // where the option label is not found in the mergedOptionLabelMappings. This can happen when
  // the option is not found in external options or the legacy reference resolvers
  return rawOptions.reduce((acc, option) => Object.assign({}, acc, {
    [option]: mergedOptionLabelMappings[option] || option
  }), {});
};
export default useReferenceOptions;